import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMe } from "./hooks/useMe";

function AppAuth() {
  const location = useLocation();
  const { isLoading, isError } = useMe();

  if (isLoading) {
    return <></>;
  }
  if (isError) {
    return <Navigate to="/unauthorized" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

export default AppAuth;
